<template>
    <template v-if="mode === 'table'">


<v-btn
variant="outlined"
:href="$store.state.mainurl+publicPath+$route.path+'/'+rowobject.id" target="_blank"
>
{{v}}
<!-- <a :href="'http://localhost:8080/#'+$route.path+'/'+rowobject.id" target="_blank">{{v}}</a> -->
<!-- тут надо научиться получать норм ссылку на образец-->
<!-- {{ meta.columns[1].widget.properties.dataset_id}} -->
<!-- @click="$router.push(column.widget.properties.dataset_id+'/'+modelValue.id)" target="_blank"
  @click="$router.push(meta.dataset_id+'/'+rowobject.id)"

$store.state.mainurl+'/dist/#'+
-->

</v-btn>
    </template>
    
    <template v-else-if="mode === 'edit'">

        <!-- <div class="field">
            <label class="label">{{column.title}}</label>
            <div class="control">
                <input class="input" type="text" v-model="v"  @input="handleInput">
            </div>
        </div> -->
        <!-- <v-text-field :label=column.title variant="outlined" v-model="v"  @input="handleInput"></v-text-field> -->
        <v-text-field :label=column.title variant="outlined" v-model="v" ></v-text-field> 
        <!--v-text-field :label=column.title variant="outlined" v-model="v"  readonly ></v-text-field
        Ve:{{ ve }} V{{v}} MV:{{ modelValue }}
        --> 
        
    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>
 
<!--{{row.link_to_specimen.id}}

rowobject.link_to_specimen.id //material id
@click="$router.push(rowobject.ref_classname_147o+'/'+rowobject.link_to_specimen.id)"
 @click="$router.push(rowobject.classname+'/'+rowobject.id)"


rowobject.ref_classname_147o // table id


-->

<script>
export default {
    name: 'objectview-widget',
    props:['mode','column', 'modelValue', 'rowobject', 'meta'], // попробовать найти путь в column
    emits: ['update:modelValue'],
    data(){ 
//   console.log(this.modelValue)
//   console.log(this.column)
// let vvalue = null;
// if (this.modelValue == null){
//     vvalue = null; // получается здесь надо сделать запрос к последовательности ? 
//     this.handleInput();
// }
// else {
//     vvalue = this.modelValue;
// }
        return {
            v: this.modelValue,
            publicPath: '',
//ve: undefined,
 //           v: vvalue,
//            link: this.column.widget.properties.dataset_id+'/'+this.modelValue.id,
//            routename: '',
        }
    },

    mounted(){
        this.publicPath = process.env.BASE_URL+'#';
//console.log(this.publicPath, process.env.BASE_URL);
// console.log(this.publicPath);
// if ($store.state.mainurl.includes('https://isling.org')){
//     this.publicPath = '/dist/#';
// }
// else {
//     this.publicPath = '';
// }
//если\когда морда будет лежать в корне (а не в дисте) - этот участок надо будет переписать (компоненты ClassifyWidget.vue, ObjectviewWidget.vue)
    },


    methods:{ 
        handleInput () {            
//           this.v = e.target.value;            
           this.$emit('update:modelValue', this.v)
        },
       // getMaterialName () {
            /*
            let routename = $route.name;
            if (routename=='lichenstables')  { this.materialname = 'lichensdatamaterial';}
            else {
                this.materialname = 'lichensdatamaterial';
                 }
                 */
          //       this.materialname = 'lichensdatamaterial';
          //       console.log(materialname);
            
       // },
       /*
        writeStoreTid(){
            this.$store.commit('getTableIdTo', this.meta.dataset_id); // криво?
        },
*/
    },
}
</script>
